import { Zap } from "lucide-react";
import Image from "next/image";
import { CDN_URL } from "@/consts";

export const HeroButton = () => (
  <div className="flex items-center justify-center gap-x-6">
    <a
      href="https://crayo.ai/dashboard"
      className="relative rounded-full bg-[#335CFF] px-8 py-5 duration-200 ease-in-out hover:scale-[1.01]"
    >
      <span className="relative z-10 flex flex-row items-center gap-4 text-lg font-medium tracking-wide text-white md:text-[26px]">
        <Zap className="h-[1em] w-auto fill-white text-white" />
        Try Crayo Now
      </span>
      <Image
        src={`${CDN_URL}/landing/trusted-by-desktop.png`}
        alt="Crayo Logo"
        width={321}
        height={237}
        className="absolute right-0 top-0 max-h-[70px] w-auto translate-x-full max-sm:hidden xl:hidden"
      />
    </a>
  </div>
);
